import { Component, Inject, InjectionToken, Injector, Optional, ViewEncapsulation } from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';

export type TFiUserEditDataFieldAddress_Settings = {
    isNewAddButtonLayout: boolean;
};
export const FiUserEditDataFieldAddress_Settings = new InjectionToken<TFiUserEditDataFieldAddress_Settings>(
    'FiUserEditDataFieldAddress_Settings',
);

@Component({
    selector: 'data-field-edit-address',
    template: `
        <fi-addresses
            [addresses]="dataFieldObject.Addresses"
            [isRequired]="dataField.IsSetRequired"
            [isNewAddButtonLayout]="isNewAddButtonLayout()"
        ></fi-addresses>
    `,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'data-field-edit-address' },
    standalone: false,
})
export class DataFieldEditAddressComponent extends DataFieldEditBase {
    constructor(
        injector: Injector,
        @Optional()
        @Inject(FiUserEditDataFieldAddress_Settings)
        private settings: TFiUserEditDataFieldAddress_Settings,
    ) {
        super(injector);
    }

    isNewAddButtonLayout(): boolean {
        return this.settings?.isNewAddButtonLayout;
    }
}
